
export default {
	props: {
		educator_id: {
			type: String|Number,
			required: false
		}
	},
    data() {
        return {
            initialFilterObject: {
                authorid: [this.educator_id || this.$parent.educator.id],
                status: [5]
            }
        };
    }
}
